/**
 * @generated SignedSource<<f5e77e96799aa7cd7ae8e1d5d5d65be8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type designFontLoaderQuery$variables = Record<PropertyKey, never>;
export type designFontLoaderQuery$data = {
  readonly fontFamilies: ReadonlyArray<{
    readonly cssUrl: string;
    readonly name: string;
  }>;
};
export type designFontLoaderQuery = {
  response: designFontLoaderQuery$data;
  variables: designFontLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cssUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "designFontLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FontFamily",
        "kind": "LinkedField",
        "name": "fontFamilies",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "designFontLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FontFamily",
        "kind": "LinkedField",
        "name": "fontFamilies",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a96703a13c977fe28b10916f854a2ae",
    "id": null,
    "metadata": {},
    "name": "designFontLoaderQuery",
    "operationKind": "query",
    "text": "query designFontLoaderQuery {\n  fontFamilies {\n    name\n    cssUrl\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "65a310ac221132d17df1083b65c2a6df";

export default node;
